export default __webpack_public_path__ + "static/media/overview-assign-img.6123a0cd.svg";